import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eecb0a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-auto" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(`tw-px-[20px] tw-py-[40px] sm:tw-p-[40px] tw-flex tw-flex-col tw-gap-[25px]`)
}
const _hoisted_3 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-flex-col tw-justify-between tw-w-full tw-min-h-[51px] tw-gap-2.5`)
}
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2.5 tw-h-[21px]" }
const _hoisted_5 = { class: "tw-text-[#211F58] tw-text-[16px] tw-font-[600] tw-not-italic tw-leading-[21px]" }
const _hoisted_6 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-[400] tw-leading-normal" }
const _hoisted_7 = { class: "tw-font-bold" }
const _hoisted_8 = {
  key: 2,
  class: "tw-text-center tw-font-[400] tw-leading-[145%] tw-text-[15px] tw-text-[#878787]"
}

import SuggestionActionsTable from "@/components/recommend/suggestedActionsTable.vue";

import { dataActionTableColumn } from "./actionsTable.vue";
import { computed } from "vue";
import { Ref } from "vue";
import store from "@/store";
import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'addNewActionSuggestedTab',
  emits: ["update:use"],
  setup(__props, { emit }) {

const dataSuggestedActionTable: Ref<dataActionTableColumn[]> = computed(() => {
  const recommendState = store.state.Recommend;
  if (!recommendState) {
    return [];
  }
  const checklistGroupMetrics =
    recommendState.recommendChecklistGroupMetrics || [];
  const checklistGroupTemplateMetrics =
    recommendState.ChecklistGroupTemplateMetrics || [];

  const dataFilterByGroupId = checklistGroupMetrics.flatMap((item) => {
    return item.checklistGroupTemplateIds || [];
  });

  const filteredChecklistGroupTemplateMetrics =
    checklistGroupTemplateMetrics.filter((item) => {
      return !dataFilterByGroupId.includes(item.id);
    });

  return filteredChecklistGroupTemplateMetrics;
});



const handleUseAction = (data: dataActionTableColumn) => {
  emit("update:use", data);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (dataSuggestedActionTable.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
                "app-assess-recommendations-create-action-suggested-tab-title-1",
              )), 1)
            ]),
            _createElementVNode("span", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-assess-recommendations-create-action-suggested-tab-description-1",
            ).split("{##titleButton##}")[0]) + " ", 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
              "app-assess-recommendations-create-action-button-title-use-1",
            )), 1),
              _createTextVNode(" " + _toDisplayString(_unref(getComponentUiText)(
              "app-assess-recommendations-create-action-suggested-tab-description-1",
            ).split("{##titleButton##}")[1]), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (dataSuggestedActionTable.value.length > 0)
        ? (_openBlock(), _createBlock(SuggestionActionsTable, {
            key: 1,
            class: "tw-mb-[40px]",
            "data-row": dataSuggestedActionTable.value,
            "header-class": 'tw-h-[56px] tw-items-center tw-ml-[7px]',
            "row-class": 'tw-ml-[7px]',
            "title-button": 
          _unref(getComponentUiText)(
            'app-assess-recommendations-create-action-button-title-use-1',
          )
        ,
            "title-action-value": 
          _unref(getComponentUiText)(
            'app-assess-recommendations-make-plan-table-action-1',
          )
        ,
            "is-show-checkbox": false,
            "is-show-meatball": false,
            "is-show-loading": true,
            onUpdateAddAction: _cache[0] || (_cache[0] = ($event: any) => (handleUseAction($event)))
          }, null, 8, ["data-row", "title-button", "title-action-value"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
            "app-assess-recommendations-section-action-empty-suggest-action-table-title-1",
          )), 1))
    ])
  ]))
}
}

})